import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_Interface } from 'src/app/Interface/Calibration_Interface';
import { Certificate_Interface, Empty_Certificate_Interface } from 'src/app/Interface/Certificate_Interface';
import { Customer_Interface, Empty_Customer_Interface } from 'src/app/Interface/Customer_Interface';
import { Customer_List_Interface, Empty_Customer_List_Interface } from 'src/app/Interface/Customer_List_Interface';
import { Empty_ExpertCalibration_Interface, ExpertCalibration_Interface } from 'src/app/Interface/ExpertCalibration_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { CertificateService } from 'src/app/Service/Certificate/Certificate.service';
import { CustomerService } from 'src/app/Service/Customer/Customer.service';
import { ExpertCalibrationService } from 'src/app/Service/ExpertCalibration/ExpertCalibration.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-CertificateForm',
  templateUrl: './CertificateForm.component.html',
  styleUrls: ['./CertificateForm.component.scss']
})
export class CertificateFormComponent implements OnInit {

  Token:String=""
  Customerpage:number=0;

  constructor(
    private Customer_Service:CustomerService,
    private modalService: BsModalService,
    private Alerify:AlertifyService,
    private Nav_Service:NavService,
    private ExpertCalibration_Service:ExpertCalibrationService,
    private Certificate_Service:CertificateService,
    private Calibration_Service:CalibrationService,
  ) { }

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');

    this.Nav_Service.CheckValidPage(this.Token,11).subscribe(
      data=>{
        this.Read_GetDetailCount()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }


  current_Month:number=0
  current_Year:number=0
  last_Month:number=0

  Read_GetDetailCount(){
    this.Certificate_Service.GetDetailCount(this.Token).subscribe(
      data=>{
        this.current_Month=data['current_Month']
        this.current_Year=data['current_Year']
        this.last_Month=data['last_Month']

        this.ReadData_ExpertCalibration()
      }
    )
  }



    //#region  Customer
    ProcssingCustomer:boolean=false
    modalRef_Customer: any;

    Search_CodeName_Customer_Table:string=''
    Search_Type_Customer_Table:string='2'

    DataList_Customer:Array<Customer_List_Interface>=[]
    Data_Seleted_Customer:Customer_List_Interface=Empty_Customer_List_Interface()

    ReadData_Customer_KeySearch_Timer:any
    ReadData_Customer_KeySearch(){

      if (this.ReadData_Customer_KeySearch_Timer) {
        clearTimeout(this.ReadData_Customer_KeySearch_Timer);
        this.ReadData_Customer_KeySearch_Timer = null;
    }

    this.ReadData_Customer_KeySearch_Timer = setTimeout(function (){
      this.ReadData_Customer()
    }.bind(this), 1000);

    }

    ReadData_Customer(){

      if(!this.Search_CodeName_Customer_Table)
      {
        this.DataList_Customer=[]
      }
      else{

        this.ProcssingCustomer=true
          this.Customer_Service.GetSearchCertificate(this.Token,this.Search_CodeName_Customer_Table).subscribe(
            data=>{
              this.DataList_Customer=data
              this.ProcssingCustomer=false
            },error=>{
              localStorage.clear()
              location.reload();

            }
          )
      }
    }


    openModal_Customer(template: TemplateRef<any>) {
      this.modalRef_Customer = this.modalService.show(template);
    }

    Set_Selected_Customer_Record(item){
      this.Data_Seleted_Customer=item
      this.modalRef_Customer.hide()
    }

    //#endregion


    //#region  Calibration Technician
    modalRef_ExpertCalibration: any;
    Procssing_ExpertCalibration:boolean=false

    openModal_ExpertCalibration(template: TemplateRef<any>) {
      this.modalRef_ExpertCalibration = this.modalService.show(template);
    }

    ExpertCalibrationpage:number=0;
    Filter_Familly:string=''
    Filter_Area:string=''

    Change_Filter(){
      this.ExpertCalibrationpage=0
    }

    ReadData_ExpertCalibration(){
      this.Procssing_ExpertCalibration=true

      this.ExpertCalibration_Service.GetActiveList(this.Token,true,true,true).subscribe(
        data=>{
          this.DataList_ExpertCalibration=data
          this.Procssing_ExpertCalibration=false
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }

    Data_Seleted_ExpertCalibration:ExpertCalibration_Interface=Empty_ExpertCalibration_Interface()
    DataList_ExpertCalibration:Array<ExpertCalibration_Interface>=[]

    Set_Selected_ExpertCalibration_Record(item){
      this.Data_Seleted_ExpertCalibration=item
      this.modalRef_ExpertCalibration.hide()
    }

    //#endregion


    //#region Receipt Number
    modalRef_Recipt: any;
    Procssing_Recipt:boolean=false
    DataList_Calibration:Array<Calibration_Interface>=[]
    DataList_Calibration_Seleted_Indexer:number=-1
    Calibrationpage:number=0
    Filter_Device_Code:string=''
    Filter_Device_Name:string=''

    Change_Filter_Device_Code(){
      this.Calibrationpage=0
    }

    openModal_Recipt(template: TemplateRef<any>,indexer) {
      this.DataList_Calibration_Seleted_Indexer=indexer
      this.Read_Calibration()
      this.modalRef_Recipt = this.modalService.show(template);
    }

    Read_Calibration(){
      this.DataList_Calibration=[]
      this.Calibrationpage=0
      this.Procssing_Recipt=true
      this.Calibration_Service.GetReception(this.Token,this.Data_Seleted_Customer.id).subscribe(
        data=>{
          this.Procssing_Recipt=false
          this.DataList_Calibration=data
        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }

    Set_Selected_Calibration_Record(item){


      var Check_Record_Data_List_Calibration_Status:boolean=false;
      for(let itemDetail of this.Data_Seleted_Certificate)
      {
        if(itemDetail.id==item.id)
        {
          Check_Record_Data_List_Calibration_Status=true
          break;
        }
      }

      if(Check_Record_Data_List_Calibration_Status)
      {
        this.Alerify.ErrorMessage("You have selected this instrument for another calibration certificate")
      }
      else{
        if(item.device_code)
        {
          this.Data_Seleted_Certificate[this.DataList_Calibration_Seleted_Indexer].device_code=item.device_code
        }
        else{
          this.Data_Seleted_Certificate[this.DataList_Calibration_Seleted_Indexer].device_code=item.device_serial
        }

        this.Data_Seleted_Certificate[this.DataList_Calibration_Seleted_Indexer].id=item.id;
      }
      this.modalRef_Recipt.hide()
    }


    //#endregion




    //#region Upload
    Data_Seleted_Certificate:Array<Certificate_Interface>=[]
    ProcssingUpload:boolean=false
    InProccessing:boolean=false

    FormUploader_tedad_bargashti:number=0
    FormUploader_elat:string="1"

    upload(files) {
      if (files.length === 0)
        return;

      const formData = new FormData();
      for (const file of files) {
        formData.append(file.name, file);
      }

      this.ProcssingUpload=true

      this.Certificate_Service.uploadFile(formData,this.Data_Seleted_ExpertCalibration.id).subscribe(
        data=>{
          var Counter=0;
          this.ProcssingUpload=false

          for(let item of data)
          {
              if(item.id==0)
              {
                this.Alerify.ErrorMessage(item.filename)
              }
              else{
                Counter=Counter+1
                this.Data_Seleted_Certificate.push(item)
              }
          }

          if(Counter>0)
          {
            this.Alerify.SuccessMessage("The file was uploaded successfully")
          }

        },error=>{
          localStorage.clear()
          location.reload();

        }
      )

    }

    SubmitCertificate(){
      this.InProccessing=true
      this.modalRef_FinishForm.hide()

      this.Certificate_Service.AddCertificate(
        this.Data_Seleted_Certificate,
        this.Data_Seleted_Customer.id,
        this.Data_Seleted_ExpertCalibration.id,
        this.FormUploader_tedad_bargashti,
        Number(this.FormUploader_elat),
        this.Token).subscribe(

        data=>{
          this.InProccessing=false
          for(let item of data)
          {
            if(item.id==-1){
              this.Alerify.ErrorMessage("The selected calibration certificate code already exists in the list")
            }
            else if(item.id==-2){
              this.Alerify.ErrorMessage("The file cannot be registered for "+item.certificate_no+" due to the calibration technician and customer capacity limits.")
            }
            else{
              this.Alerify.SuccessMessage("The information was registered successfully")
              this.Data_Seleted_Certificate=[]
              this.Read_GetDetailCount()
            }
          }

        },error=>{
          localStorage.clear()
          location.reload();

        }
      )
    }

    modalRef_FinishForm:any;

    openModal_FinishForm(template: TemplateRef<any>) {
      var Check_Record_Data_List_Calibration:number=-1;
      var Check_Record_Data_List_Calibration_Status:boolean=false;
      for(let item of this.Data_Seleted_Certificate)
      {
        Check_Record_Data_List_Calibration=Check_Record_Data_List_Calibration+1
        if(item.device_code=='' || item.device_code==null)
        {
          Check_Record_Data_List_Calibration_Status=true
          break;
        }
      }

      if(Check_Record_Data_List_Calibration_Status)
        this.Alerify.ErrorMessage("Please enter the ID for row "+(Check_Record_Data_List_Calibration+1)+"")
      else
        this.modalRef_FinishForm = this.modalService.show(template);
    }

    Certificate_Delete(id){
      this.Data_Seleted_Certificate.splice(id,1)
      this.Alerify.SuccessMessage("Deleted successfully")
    }
    //#endregion

}
